import React from 'react';
import { CommandBarButton, IconButton } from '@fluentui/react';
import DetailsTable from '../../../../Table/DetailsTable';
import FeatureSummary from '../../../../Util/FeatureSummary';

const CTATable = ({ items,loading, editOnClick, createOnClick,cloneOnClick}) => {
    const columns = [
        {
            minWidth: 30,
            maxWidth: 30,
            onRender: (item) => (
                <ContextualMenu editOnClick={editOnClick} id={item.callToActionId} cloneOnClick={cloneOnClick}/>
            ),
        },
        {
            name: 'CoBrandID',
            fieldName: 'cobrandId',
            minWidth: 120,
            maxWidth: 120,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        },
        {
            name: 'title',
            fieldName: 'title',
            minWidth: 140,
            maxWidth: 140,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        },
        {
            name: 'onForUs',
            fieldName: 'onForUs',
            minWidth: 200,
            maxWidth: 200,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        },
        {
            name: 'onForInternational',
            fieldName: 'onForInternational',
            minWidth: 200,
            maxWidth: 200,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        },
        {
            name: 'showOnArticles',
            fieldName: 'showOnArticles',
            minWidth: 200,
            maxWidth: 200,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        },
        {
            name: 'showOnStart',
            fieldName: 'showOnStart',
            minWidth: 200,
            maxWidth: 200,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        },
        {
            name: 'showOnInfographics',
            fieldName: 'showOnInfographics',
            minWidth: 200,
            maxWidth: 200,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        },
        {
            name: 'showOnVideos',
            fieldName: 'showOnVideos',
            minWidth: 200,
            maxWidth: 200,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        },
        {
            name: 'showOnTools',
            fieldName: 'showOnTools',
            minWidth: 200,
            maxWidth: 200,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        },
        {
            name: 'showOnMeditations',
            fieldName: 'showOnMeditations',
            minWidth: 200,
            maxWidth: 200,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        },
        {
            name: 'showOnJournals',
            fieldName: 'showOnJournals',
            minWidth: 200,
            maxWidth: 200,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        },
        {
            name: 'priorityOnCustomClientPage',
            fieldName: 'priorityOnCustomClientPage',
            minWidth: 200,
            maxWidth: 200,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        },
        {
            name: 'unitOnOffDefault',
            fieldName: 'unitOnOffDefault',
            minWidth: 200,
            maxWidth: 200,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        },
        { name: 'countryOnOffDefault',
            fieldName: 'countryOnOffDefault',
            minWidth: 200,
            maxWidth: 200,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        }
    ];



    return (
        <>
            <DetailsTable
                items={items}
                columns={columns}
                loading={loading}
                mainColumn={'title'}
                style={{
                    position: 'relative',
                    height: '80vh',
                    width: '80vw',
                }}
                CommandBar={
                    <CommandBarButton
                        iconProps={{ iconName: 'Edit' }}
                        text="Add Call To Action"
                        onClick={() => createOnClick()}
                    />
                }
            />
            <FeatureSummary
                label="About Dashboard CTAs"
                summary="This table displays all call-to-action (CTA) items for cobrands, including their title, display settings, and priority. You can add, edit, or clone CTAs. The Call To Action feature allows cobrands to highlight important actions or content for users across various parts of the platform."
            />
        </>
    );
};

const moreIcon = { iconName: 'More' };

const ContextualMenu = ({ editOnClick, cloneOnClick, id, ...rest }) => {
    const menuProps = {
        items: [
            {
                key: 'print',
                iconProps: { iconName: 'Edit' },
                text: 'Edit',
                onClick: () => editOnClick(id),
            },
            {
                key: 'print',
                iconProps: { iconName: 'Edit' },
                text: 'Clone',
                onClick: () => cloneOnClick(id),
            },
        ],
    };

    return <IconButton iconProps={moreIcon} menuProps={menuProps} onRenderMenuIcon={() => {}} {...rest} />;
};

export default CTATable;
